<p>
  mini-chart-from-stock-view works!
</p>
